import { defineStore } from 'pinia';
import { computed, ref } from 'vue';
import type AdminUserInterface from '@/domains/admin/typescript/AdminUserInterface';

export default defineStore('adminUser', () => {
    const users = ref<AdminUserInterface[]>();
    const selectedUser = ref<AdminUserInterface>();
    const totalUsers = ref(0);

    const hasUserSelected = computed<boolean>(() => selectedUser.value !== undefined);

    function selectUserById(userId: string): void {
        selectedUser.value = users.value?.find((user) => user.id === userId);
    }

    function isUserSelected(user: AdminUserInterface): boolean {
        return selectedUser.value?.id === user.id;
    }

    function unselectUser(): void {
        selectedUser.value = undefined;
    }

    function getUserById(id: string): AdminUserInterface | undefined {
        return users.value?.find((user) => user.id === id);
    }

    function replaceUser(user: AdminUserInterface): void {
        if (!users.value) {
            return;
        }
        const index = users.value.findIndex((existingUser) => existingUser.id === user.id);
        if (index !== -1) {
            users.value[index] = user;
        }
    }

    function removeUser(userId: string): void {
        if (!users.value) {
            return;
        }
        users.value = users.value.filter((user) => user.id !== userId);
        if (selectedUser.value?.id === userId) {
            unselectUser();
        }
    }

    function $reset() {
        users.value = undefined;
        selectedUser.value = undefined;
    }

    return {
        users,
        selectedUser,
        hasUserSelected,
        totalUsers,
        selectUserById,
        isUserSelected,
        unselectUser,
        getUserById,
        replaceUser,
        removeUser,

        $reset,
    };
});
